import { Link as ChakraLink, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { configFile } from '@/config';
import CardPostHeader from './CardPostHeader';
// import useTranslation from "next-translate/useTranslation";

interface Props {
  articles: any[];
  content: any[];
}

export default function HeaderModal({ articles, content }: Props) {
  const [firstArticles, setFirstArticles] = useState<any>([]);
  const [lastArticles, setLastArticles] = useState<any>([]);
  const [itensPerRow, setItensPerRow] = useState(3);

  useEffect(() => {
    setItensPerRow(window.innerWidth >= 1288 ? 3 : 2);
  }, [articles]);

  useEffect(() => {
    if (content.length === 0) {
      setFirstArticles(articles.slice(0, itensPerRow));
      setLastArticles(articles.slice(itensPerRow, articles?.length));
    } else {
      setFirstArticles(articles.slice(0, itensPerRow - 1));
      setLastArticles(articles.slice(itensPerRow - 1, articles?.length));
    }
  }, [itensPerRow, content]);

  return (
    <Flex h="100%" margin="0 auto" alignItems="center" justifyContent="flex-start" gap="28px">
      {content.length > 0 ? (
        <Flex direction="column" gap="24px" justifyContent="flex-start" h="100%" borderRight="2px solid #E2E8F0">
          {content.map((item: any, i: number) => (
            <Flex
              key={i}
              justifyContent="space-between"
              alignItems="center"
              gap="24px"
              minWidth="198px"
              maxWidth="257px"
            >
              <Text fontSize="md" lineHeight="6" fontWeight="600" color="gray.600">
                {item.name}
              </Text>
            </Flex>
          ))}
        </Flex>
      ) : null}

      {Boolean(firstArticles) &&
        firstArticles.map((article: any, i: number) => <CardPostHeader data={article.articles.data} key={i} />)}
      <Flex direction="column" gap="20px" h="100%" wrap="nowrap" basis="1" grow="1" minWidth="198px" maxWidth="257px">
        <Flex justifyContent="space-between" alignItems="center" gap="19px">
          <Text fontSize="md" lineHeight="6" fontWeight="semibold" color="gray.800">
            Itens
          </Text>
          <ChakraLink
            w="max-content"
            as={Link}
            href="/blog"
            fontSize="xs"
            lineHeight="4"
            fontWeight="normal"
            color={configFile.primaryAccentColor}
          >
            ver mais →
          </ChakraLink>
        </Flex>
        <Flex flexDir="column" gap="16px">
          {Boolean(lastArticles) &&
            lastArticles.map((article: any, i: number) => (
              <Text
                key={i}
                as={Link}
                href={`/blog/${article.articles.data[0].attributes?.url}`}
                fontSize="md"
                fontWeight="normal"
                lineHeight="24px"
                color="gray.400"
                maxW="100%"
                _hover={{
                  color: configFile.primaryAccentColor,
                  _before: { bgColor: configFile.primaryAccentColor },
                }}
                _before={{
                  display: 'inline-block',
                  marginRight: '16px',
                  content: '""',
                  w: '7px',
                  h: '7px',
                  bgColor: 'gray.400',
                  borderRadius: '100%',
                  marginBottom: '2px',
                }}
              >
                {article?.articles.data[0].attributes?.title}
              </Text>
            ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
